import { render } from "./specialDetail.vue?vue&type=template&id=a817d2d6&scoped=true"
import script from "./specialDetail.vue?vue&type=script&lang=js"
export * from "./specialDetail.vue?vue&type=script&lang=js"

import "./specialDetail.vue?vue&type=style&index=0&id=a817d2d6&lang=scss&scoped=true"
import "./specialDetail.vue?vue&type=style&index=1&id=a817d2d6&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a817d2d6"]])

export default __exports__